import { monthNames } from '/src/lib/constants';
import { Nullable } from '/src/lib/types';

export * from './axis-label';
export * from './chart';
export * from './color-scale';
export * from './dimensions';
export * from './domain';
export * from './filter';
export * from './margins';
export * from './position';
export * from './range';
export * from './scale';
export * from './ticks';

/**
 * Utility Functions
 */

/**** Data ****/

// Month name database
export const getMonths = () => monthNames;

/**** Sorting ****/

// Sorts data from largest to smallest
export const dataSorter = (array: any[], sortProperty: string) => {
  if (!array) return;
  array.sort(function (a, b) {
    return a[sortProperty] - b[sortProperty];
  });
  return array;
};

// /**** Media Queries ****/

// // Checks for mobile
// export const isMobile = function () {
//   return $mdMedia('sm');
// };

/**** DOM ****/

// Get element width
export const getWidth = (element?: Nullable<HTMLElement>, id = 'totalBarChart') => {
  if (!element || document.getElementById(id) === null) return 0;
  return document.getElementById(id)?.getBoundingClientRect().width;
};

/**** Calculations ****/

// Calculates bar widths based on screen size and returns a width divisible by 2
export const getBarWidth = (chartWidth: number, divisor: number) => {
  if (!chartWidth || !divisor) return 0;
  let width = Math.round(chartWidth / divisor);
  if (width % 2) width += 1;
  return width;
};

/**** Text Formatting ****/

// Strips punctuation
export const stripPunctuation = (string?: string) => {
  if (string) {
    let newString = string.replace(/[.,-/#!$%^&*;:{}=\-_`~()]/g, '');
    newString = newString.replace(/\s{2,}/g, ' ');
    return newString;
  }
};

// Converts normal text to camelCase
export const toCamelCase = (string?: string) => {
  if (string === undefined) return '';
  return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

// Converts camelCase to normal text
export const convertCamelCase = (string: string) => {
  if (string.charAt(0) === string.charAt(0).toLowerCase()) {
    const withSpaces = string.replace(/([A-Z])/g, ' $1');
    const finalString = withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
    return finalString;
  }
};
